import { Link } from 'react-router-dom';
import type { BlogPost } from '../../../mocks/blog';

interface ArticleRelatedProps {
  posts: BlogPost[];
}

export default function ArticleRelated({ posts }: ArticleRelatedProps) {
  if (posts.length === 0) return null;

  return (
    <section className="bg-zinc-900/50 border-t border-zinc-800/60 py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <p className="text-orange-400 text-xs uppercase tracking-widest font-semibold mb-2">Čítajte ďalej</p>
            <h3 className="text-white text-3xl font-black">Súvisiace články</h3>
          </div>
          <Link
            to="/blog"
            className="hidden sm:flex items-center gap-2 text-zinc-400 hover:text-white text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Všetky články
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.id}`}
              className="group flex flex-col bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden hover:border-orange-500/30 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="flex flex-col flex-1 p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className={`text-xs font-semibold rounded-full px-3 py-1 ${post.categoryColor}`}>
                    {post.category}
                  </span>
                  <span className="text-zinc-600 text-xs">{post.readTime}</span>
                </div>
                <h4 className="text-white font-bold text-base leading-snug mb-3 group-hover:text-orange-300 transition-colors duration-200 flex-1">
                  {post.title}
                </h4>
                <div className="flex items-center gap-2 pt-3 border-t border-zinc-800">
                  <div className="w-6 h-6 rounded-full overflow-hidden border border-zinc-700">
                    <img src={post.authorImage} alt={post.author} className="w-full h-full object-cover object-top" />
                  </div>
                  <span className="text-zinc-500 text-xs">{post.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="sm:hidden mt-8 text-center">
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 text-zinc-400 hover:text-white text-sm font-medium border border-zinc-700 hover:border-zinc-500 px-5 py-2.5 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Všetky články
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
